import { computed, defineComponent, reactive, ref, watch } from "vue";
import { Log } from "~/extensions/utils";
import { api } from "~/api";
import date from 'quasar/src/utils/date/date.js';
import { FindShomeiList } from "~/api/shomei/commands/FindShomeiList";
import { MsgBox } from "~/components/MsgBox";
import { useRouter } from "vue-router";
import { myPageStore } from "~/store/MyPageStore";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
const log = Log.create("ShomeiListTable");
export default defineComponent({
    name: "ShomeiListTable",
    async setup() {
        const data = reactive({ items: [] });
        const personal = reactive(myPageStore.personal);
        const allItems = ref([]);
        const loading = ref(false);
        const router = useRouter();
        const columns = computed(() => {
            const base = [
                {
                    name: "shomeiNo",
                    label: "申請番号",
                    align: "left",
                    style: "width: 15%",
                    field: (row) => row.shomeiNo,
                    sortable: true
                },
                {
                    name: "shomeiKbName",
                    label: "証明書名",
                    align: "left",
                    style: "width: 20%",
                    field: (row) => row.shomeiKbName,
                    sortable: true
                },
                {
                    name: "shinseiDate",
                    label: "申請日",
                    align: "center",
                    style: "width: 10%",
                    field: (row) => (row.shinseiYmd ? date.formatDate(row.shinseiYmd, "YYYY/MM/DD") : ""),
                    sortable: true
                },
                {
                    name: "shomeiStatusName",
                    label: "発行状況",
                    align: "left",
                    style: "width: 10%",
                    field: (row) => row.shomeiStatusName,
                    sortable: true
                },
                {
                    name: "tuisekiNo",
                    label: "追跡番号",
                    align: "left",
                    style: "width: 20%",
                    field: (row) => row.tuisekiNo,
                    sortable: false
                },
                {
                    name: "remarks",
                    label: "備考",
                    align: "left",
                    style: "width: 20%",
                    field: (row) => row.shomeiBikou,
                    sortable: false
                }
            ];
            if (myPageStore.isMultipleKeiyaku) {
                base.splice(1, 0, {
                    name: "buknName",
                    label: "物件名",
                    align: "left",
                    style: "width: 15%",
                    field: (row) => getBuknName(row.orgNyukyokeiyakuNo),
                    sortable: true
                });
                base.splice(2, 0, {
                    name: "roomNo",
                    label: "部屋番号",
                    align: "left",
                    style: "width: 10%",
                    field: (row) => getRoomNo(row.orgNyukyokeiyakuNo),
                    sortable: true
                });
            }
            return base;
        });
        // 初期表示処理
        const initView = async () => {
            try {
                loading.value = true;
                const query = new FindShomeiList();
                allItems.value = await api.shomei.findAll(query);
                const index = computed(() => personal.nyukyokeiyakuList.findIndex(x => x.orgNyukyokeiyakuNo === myPageStore.selectedNyukyokeiyakuNo));
                // 初期フィルター
                data.items = allItems.value.filter(item => item.orgNyukyokeiyakuNo === myPageStore.personal.nyukyokeiyakuList[index.value].orgNyukyokeiyakuNo);
            }
            catch (ex) {
                MsgBox.error(ex.message);
            }
            finally {
                loading.value = false;
            }
        };
        const onRowClick = (evt, row) => {
            router.push({ name: "shomei-shinsei-entry-check", query: { shomeiNo: row.shomeiNo } });
        };
        const onCardClick = (props) => {
            router.push({ name: "shomei-shinsei-entry-check", query: { shomeiNo: props.key } });
        };
        const getBuknName = (orgNyukyokeiyakuNo) => {
            const nyukyokeiyaku = myPageStore.personal.nyukyokeiyakuList.find(x => x.orgNyukyokeiyakuNo === orgNyukyokeiyakuNo);
            return nyukyokeiyaku ? nyukyokeiyaku.bukkenName : "";
        };
        const getRoomNo = (orgNyukyokeiyakuNo) => {
            const nyukyokeiyaku = myPageStore.personal.nyukyokeiyakuList.find(x => x.orgNyukyokeiyakuNo === orgNyukyokeiyakuNo);
            return nyukyokeiyaku ? nyukyokeiyaku.roomNumber : "";
        };
        watch(() => myPageStore.selectedNyukyokeiyakuNo, newVal => {
            if (!isNullOrUndefined(newVal) && newVal !== -1) {
                try {
                    data.items = allItems.value.filter(item => item.orgNyukyokeiyakuNo === newVal);
                }
                catch (e) {
                    MsgBox.error(e.message);
                }
            }
        });
        initView();
        return {
            columns,
            data,
            loading,
            onRowClick,
            onCardClick
        };
    }
});
